import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConnectionsApi } from 'osep-auth-service-client-v1';
import { useApiConfig } from '../useApiConfig';
import { CONNECTIONS_QUERY_KEY } from '../../utils/consts';

export const useDeleteConnectionMutation = () => {
  const { getAuthApiConfig, axiosInstance } = useApiConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (connectionId: string) => {
      const api = new ConnectionsApi(
        await getAuthApiConfig(),
        undefined,
        axiosInstance,
      );
      await api.deleteConnection(connectionId);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [CONNECTIONS_QUERY_KEY] });
    },
  });
};
